import { render, staticRenderFns } from "./AdminStoreGroup.vue?vue&type=template&id=64717a27&"
import script from "./AdminStoreGroup.vue?vue&type=script&lang=js&"
export * from "./AdminStoreGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports